import React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import styles from './BillDetail.module.scss';
import {emptyFn} from "presentation/common/helpers/utils";
import {Box, InlineBox, ResponsiveLayout} from "presentation/common";
import {TrashIcon, EditIcon} from "presentation/common/components/style-guide/icons";

export const BillDetailMobile = props => {
  const {onEdit, billInfo, onRemove} = props;
  return (
    <Box className={styles.billContainerMobile}>
      <InlineBox className="py-1 px-2">
        <span className={clsx("flex-auto")}>Estás haciendo una compra como <b>Empresa</b></span>
        <span className={clsx(styles.actionMobile)} onClick={onEdit}>
          <EditIcon fontSize="small" className="primary"/>
          <span className="ml-2">Editar</span>
        </span>
      </InlineBox>
      <InlineBox className="py-1 px-2">
        <span className={clsx("flex-auto")}>¿Es una compra personal?</span>

        <span className={styles.actionMobile} onClick={onRemove}>
          <TrashIcon fontSize="small" className="primary"/>
          <span className="ml-1">Eliminar</span>
        </span>
      </InlineBox>
      <div className="w-full p-2"><b>{billInfo.businessType} ({billInfo.rut})</b></div>
    </Box>
  );
};

export const BillDetailDesktop = props => {

  const {onEdit, billInfo, onRemove} = props;

  return (
    <div className={styles.billDetailContainer}>
      <div className={styles.companyDetailContainer}>
        <span className={styles.title}>Estás haciendo una compra como <span>Empresa </span>
        <span onClick={onEdit}><EditIcon fontSize="small" className="primary"/>&nbsp;Editar</span></span>
        <span className={styles.company}>{billInfo.businessType}({billInfo.rut})</span>
      </div>
      <div className={styles.personalBoxContainer}>
        <span>¿Es una compra personal?</span>
        <span className={styles.deleteMessage} onClick={onRemove}>
          <TrashIcon fontSize="small" className="primary"/>
          <span>Eliminar los datos de la empresa</span>
        </span>
      </div>
    </div>
  );
};

export const BillDetail = props => {
  return <ResponsiveLayout
    MobileComponent={BillDetailMobile}
    DesktopComponent={BillDetailDesktop}
    {...props} />
};

BillDetail.propTypes = {
  onEdit: PropTypes.func,
  onRemove: PropTypes.func,
};

BillDetail.defaultProps = {
  onEdit: emptyFn,
  onRemove: emptyFn,
};

export default BillDetail;
